export default {
  default: () => import("/home/vsts/work/1/s/UI/mycim-app/layouts/default.vue").then(m => m.default || m)
}